import { SlackIcon } from "#components/ui/SlackIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const slackManifest: IntegrationManifest = {
    key: "slack",
    displayName: "Slack",
    nameKey: "channels.slack",
    descriptionKey: "slackDescription",
    trayDescriptionKey: "composerTrayDescriptions.slack",
    cardDescriptionKey: "connectIntegration.descriptions.slack",
    connectedContentKeys: ["slackChannels", "slackDirectMessages", "slackGroupChats"],
    brandColor: "#611F69",
    iconUrl: IconAssets.Slack,
    iconUrlAlt: IconAssets.SlackAlt,
    glyph: SlackIcon,
    channelType: "Slack",
    connectorType: "Slack",
    dataSources: ["slack_message"]
};
